<div class="row">
  <div class="col-12">
    <div *ngIf="model">
      <h4>Remuneraciones</h4>
      <table class="table border-bottom mb-4">
        <tbody>
          <tr>
            <td class="fs-5"><strong>Total acción {{model.Title}}</strong></td>
            <td class="text-end fs-5"><strong>{{modelResult.TotalPrice | currency:'EUR'}}</strong></td>
          </tr>
        </tbody>
      </table>
      <table class="table table-striped table__resume">
        <thead>
          <tr>
            <th>Producto</th>
            <th class="text-center">Unidades vendidas</th>
            <th class="text-end">Remuneración</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let elem of modelResult.Detail">
            <td>{{elem.ProductType}}</td>
            <td class="text-center">{{elem.TotalUnits}}</td>
            <td class="text-end">{{elem.TotalPrice | currency:'EUR'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>